const styles = {
    container: {
        width: '100%',
        minHeight: '100vh',
        padding: 0,
        marginTop: '20px !important', // Add !important to enforce the margin
    },
    headerBox: {
        width: '100%',
        height: '200px',
        padding: 0,
        backgroundSize: 'cover',         // Cover the entire area
        backgroundPosition: 'center',     // Center the image
        backgroundRepeat: 'no-repeat',    // Do not repeat the image
        position: 'relative',
        marginTop: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: "100%",
    },
    headerTextTitle: {
        color: '#ffff',
        textAlign: 'center',
        fontFamily: 'Segoe UI',
        fontWeight: '600',
        fontSize: { xs: '30px', sm: '30px', md: '45px', lg: '50px' },
        px: 1,
        mb: 2,
    },
    headerText: {
        color: '#ffff',
        textAlign: 'center',
        fontFamily: 'Segoe UI',
        fontWeight: '600',
        fontSize: '18px',
        px: 2,
    },
    questionText: {
        width: "90%", 
        flexShrink: 0,
        color: '#0D8B5A',
        fontFamily: "Segoe UI",
        fontWeight: '600',
    },
    ansText: {
        fontFamily: "Segoe UI",
        fontWeight: '600',
    },
    fqaBox: {
        boxShadow: '0px 0px 10px 0px #00000026',
        backgroundColor: 'white', // Set background to white
        marginBottom: '26px', // Add space between accordions
        borderRadius: '8px', // Optional: rounding the corners
        textAlign: 'start',
    }
};

export default styles;
